import type { Slice } from './report.js'

/**
 * Exportação em CSV.
 *
 * *"Não porque alguém pediu, mas porque dado que não sai de um sistema é dado
 * refém."* — `Fase 11 - Relatórios`.
 *
 * ## Ponto decimal, e não vírgula
 *
 * O CSV vai para uma planilha, e uma planilha lê número. `1.234,56` em pt-BR é
 * ambíguo num arquivo separado por vírgula — o separador de milhar e o de campo
 * viram a mesma coisa. O valor sai como `1234.56`, que **toda** planilha
 * entende, e a formatação bonita fica na tela, que é onde ela pertence.
 *
 * ## Aspas em tudo que é texto
 *
 * Nome de categoria e de estabelecimento têm vírgula, aspas e quebra de linha —
 * "Bar, Café e Cia" quebraria a coluna. Aspas sempre, com a aspa interna
 * dobrada, que é o escape do RFC 4180.
 *
 * ## Nada de fórmula
 *
 * Um campo que começa com `=`, `+`, `-` ou `@` é **executado** ao abrir no Excel
 * e no Sheets — é injeção de fórmula em CSV, e ela chega por um nome de produto
 * copiado de uma nota fiscal. O prefixo apóstrofo neutraliza sem mudar o que se
 * lê.
 */

function campo(valor: string): string {
  // Fórmula neutralizada antes de qualquer coisa. Ver o cabeçalho.
  const seguro = /^[=+\-@\t\r]/.test(valor) ? `'${valor}` : valor
  return `"${seguro.replace(/"/g, '""')}"`
}

/** Centavos → `'1234.56'`. Ponto decimal, sempre. Ver o cabeçalho. */
function valor(cents: number): string {
  const abs = Math.abs(cents)
  const sinal = cents < 0 ? '-' : ''
  return `${sinal}${String(Math.trunc(abs / 100))}.${String(abs % 100).padStart(2, '0')}`
}

export function slicesToCsv(slices: Slice[], colunaRotulo: string): string {
  const linhas = [
    [campo(colunaRotulo), campo('valor'), campo('transacoes')].join(','),
    ...slices.map((s) => [campo(s.label), valor(s.cents), String(s.count)].join(',')),
  ]
  // `\r\n` é o que o RFC 4180 pede, e é o que o Excel do Windows espera. O
  // resto do mundo aceita os dois.
  return `${linhas.join('\r\n')}\r\n`
}
